import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function SubCategory({ }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [clickedSubCategoryBeforePopup, setClickedSubCategoryBeforePopup] = useState(null);

    const { setPageTitle } = useContext(LayoutContext);

    const { id } = useParams();

    const handleOpenPopup = (categoryId) => {
        setClickedSubCategoryBeforePopup(categoryId);
        setShowPopup(true);
    }

    const Box = ({ id, picture, title, childCount, triggerPopup }) => {
        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/category/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }
        if (triggerPopup) {
            return (
                <div className='bsh-4 bc-w ta-c mb-4 br-4 o-h c-p' style={{ flex: '0 0 calc(50% - .8rem)' }} onClick={e => handleOpenPopup(id)}>
                    <Img />
                    <div className='p-3' style={{ color: '#757575' }}>
                        {title}
                    </div>
                </div>
            );
        }
        return (
            <Link className='bsh-4 bc-w ta-c mb-4 br-4 o-h' style={{ flex: '0 0 calc(50% - .8rem)' }} to={(childCount == 0 ? `/products/${id}` : `/category/${id}`)}>
                <Img />
                <div className='p-3' style={{ color: '#757575' }}>
                    {title}
                </div>
            </Link>
        );
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/category/getdirectchildren?parentId=${id}`), { signal });
                const json = await response.json();
                setData(json.data);
                setPageTitle(json.data[0].parentTitle)

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        id && fetchData();

        return () => controller.abort();
    }, [id]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='d-f fw-w jc-sb p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '6rem' }}>
            {data.map(x => {
                return (
                    <Box
                        key={x.id}
                        id={x.id}
                        picture={x.picture}
                        title={x.title}
                        childCount={x.childCount}
                        triggerPopup={x.triggerPopup}
                    />
                )
            })}

            {showPopup && (
                <div className='p-f l-0 t-0 w-100vw h-100vh d-f ai-c' style={{ zIndex: 200 }}>
                    <div className='p-f l-0 t-0 w-100vw h-100vh zi-80' style={{ backgroundColor: 'rgba(0,0,0, .5)' }} onClick={e => setShowPopup(!showPopup)} />
                    <div className='p-r bc-w mx-4 zi-90 p-4 fs-3 bsh-2 br-2 w-100 fw-600' style={{ fontSize: '.99em' }}>
                        <Link className='d-f ai-c' style={{ height: '5rem' }} to={`/brands/${clickedSubCategoryBeforePopup}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                                <path fill='#4caf50' d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                            </svg>
                            <div className='mr-2'>شرکت ها و محصولات</div>
                        </Link>
                        <div style={{ height: '1px', backgroundColor: '#e6e6e6' }}></div>
                        <Link className='d-f ai-c p-r' style={{ height: '5rem', top: '.5em' }} to={`/invoice/${clickedSubCategoryBeforePopup}`}>
                            <div>
                                <div className='d-f ai-c'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 32 32">
                                        <path fill='#4caf50' d="M20.563 20.594l-1.875 1.875-8-8 8-8 1.875 1.875-6.125 6.125z"></path>
                                    </svg>
                                    <div className='mr-2'>پیش فاکتور</div>
                                </div>
                                <div style={{ color: '#8b8b8b', fontSize: '.8em', marginRight: '2.4rem' }}>
                                    دریافت آنلاین پیش فاکتور از شرکت های همراه ما
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
}